import styled from "styled-components";
import { motion } from "framer-motion";

export const Pop = styled(motion.button)`
    width: auto;
    border: 2px solid #d9d9d9;
    border-radius: 12px;
    background: white;
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 7px 10px;
    position: relative;
    will-change: width;
    transition: .3s;
    z-index: 1;

    :is([data-disabled = true]) {
        background: var(--disabled-color);
        border-color: var(--disabled-color);
        cursor: not-allowed;

        :hover {
            border-color: var(--disabled-color);

            svg.Pop__iconDefault {
                color: var(--disabled-text-color);
            }
        }
    }

    :hover {
        /* background: var(--hover-color);I */
        /* border: 2px solid var(--primary-color); */
        border: 2px solid #5da47d;

        svg.Pop__iconDefault {
            color: var(--primary-color);
        }
    }

    div.Pop__content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;

        span.Pop__content__label {
            font-size: 13px;
            font-weight: 500;
            color: var(--text-color);
            white-space: nowrap;
            margin: 0;
            padding: 0;

            small.Pop__content__label__rule {
                font-size: 10px;
                color: var(--text-color-light);
            }
        };
        div.Pop__content__selected {
            margin-top: -2px;
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 3px;
            border-radius: 8px;
            border: 2px solid #d9d9d9;
            border: none;
            color: var(--text-color);
            white-space: nowrap;
            font-weight: 700;
            font-size: 14px;

            img.Pop__content__selected__icon {
                height: 15px;
                padding-right: 3px;
            }
            .Pop__content__selected__icon_talhao {
                width: 18px;
                padding-right: 3px;
            }
            
            span.Pop__content__selected__empty {
                font-style: italic;
                font-weight: 500;
                font-size: 13px;
                color: var(--text-color-light);
                opacity: 0.8;
            }
        }
    }
    
    svg.Pop__iconDefault {
        color: var(--text-color-light);
    }
   
`;

export const ContainerList = styled(motion.div)`
    position: absolute;
    top: -40px;
    left: -10px;
    min-width: 100%;
    width: 450px;
    max-height: 50vh;
    background: #fff;
    z-index: 300;
    border-radius: 10px;
    background: white;
    box-shadow: rgba(153, 153, 153, 0.5) 0px 0px 10px;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    div.ContainerList__header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    div.newInputField {
        width: 100%;
        height: 40px;
        min-height: 40px;
        border: 2px solid var(--border-color);
        border-radius: 10px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0px 5px 0px 10px;
        gap: 8px;

        :focus-within {
            border-color: var(--primary-color);
        }

        svg.newInputField__icon {
            color: var(--text-color-light);
        }

        input {
            width: 100%;
            height: 100%;
            border: none;

            ::placeholder {
                opacity: 0.5;
                font-weight: 400;
            }
        }

        button.newInputField__close {
            width: 20px;
            height: 20px;
            border: none;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin-right: 5px;
            cursor: pointer;

            :active {
                transform: scale(0.98);
            }

            svg {
                margin: 0;
                padding: 0;
                margin-left: 1px;
            }

            :hover {
                background: rgba(255, 0, 0, 0.3);
            }
        }
    }

    div.ContainerList__list {
        width: 100%;
        overflow-y: auto;
        padding-right: 5px;

        button.ContainerList__list__item {
            margin: 0;
            padding: 0;
            width: 100%;
            min-height: 40px;
            display: flex;
            align-items: flex-start;
            align-items: center;
            /* justify-content: space-between; */
            gap: 7px;
            box-sizing: border-box;
            padding: 0px 10px;
            border: none;
            background: white;
            cursor: pointer;
            border-radius: 7px;
            transition: .2s;

            :active {
                transform: scale(0.98);
            }

            :hover {
                background:#d5ffe8;
            }

            :disabled {
                cursor: not-allowed;
            }

            :is([data-active = true]) {
                background: var(--primary-color);
                color: #fff;

                :hover {
                    background: rgb(255, 89, 92, 0.9);
                    text-decoration: line-through;
                    /* font-style: italic; */
                    text-shadow: 0px 0px 2px rgba(83, 0, 1, 0.9);
                }

                div.ContainerList__list__item__content {
                    color: white;
                }
                
                div.ContainerList__list__item__circle {
                    border-color: white;
                    background: white;
                }

                .ContainerList__list__item__svg {
                    opacity: 0;
                }

                .ContainerList__list__item__close {
                    display: block;
                    width: 17px;
                    min-width: 17px;
                    height: 17px;
                    min-height: 17px;
                    box-sizing: border-box;
                    padding: 3px;
                    border-radius: 50%;
                    background: #fff;
                    color: red;
                }
            }

            div.ContainerList__list__item__content {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 7px;
                font-size: 14px;
                text-align: left;
                color: var(--text-color);
            }
            div.ContainerList__list__item__circle {
                width: 13px;
                min-width: 13px;
                max-width: 13px;
                height: 13px;
                min-height: 13px;
                max-height: 13px;
                border: 3px solid var(--text-color-light);
                border-radius: 50%;
            }

            .ContainerList__list__item__svg {
                height: 30px;
            }
            
            .ContainerList__list__item__close {
                display: none;
            }
        
        }
    }
`;